//Import external libraries
import * as React from "react";
import { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

//Import internal resources and services
import { setUser } from "../../actions/userActions";
import { logOut } from "../../actions/authActions";
import { setUserLanguage } from "../../utils/services/userService";
import { appCtx } from "../../utils/hooks/appContext";
import slika from "../../image/T.png";
import proluxIcon from "../../image/proluxsolutions_logo.jfif";

//Import MUI components
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { Link as MuiLink } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const Navbar = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const user = useSelector((state) => state.user);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [, setOpen] = useState(false);
  const { modalOpen, setModalopen } = useContext(appCtx);
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const anchorRef = useRef(null);
  const [selectedValue, setSelectedValue] = useState(
    localStorage.getItem("i18nextLng")
  );

  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  const handleClose = (event) => {
    // if (anchorRef.current && anchorRef.current.contains(event.target)) {
    //   return;
    // }
    setSelectedValue(event.target.value);
    setOpen(false);
  };

  /*function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }*/

  const navbarInternalLoggedIn = [
    { id: 1, name: t("navbarInternal.nameAccount"), href: "/account" },
    { id: 2, name: t("navbarInternal.nameDashboard"), href: "/home" },

    { id: 3, name: t("navbarInternal.mollier"), href: "/mollier_chart" },
    { id: 4, name: t("navbarInternal.nameLogout"), href: "/" },
  ];
  {
    /*const pages = [
    {
      id: 1,
      name: t("navbarExternal.aboutUs"),
      href: "https://www.prolux-solutions.com/ch/de/ueber-uns/unternehmen",
    },
    {
      id: 2,
      name: t("navbarExternal.serviceAndTools"),
      href: "https://www.prolux-solutions.com/ch/de/auslegungssoftware-kawin",
    },
    {
      id: 3,
      name: t("navbarExternal.contact"),
      href: "https://www.prolux-solutions.com/ch/de/ueber-uns/team",
    },
  ];*/
  }
  const pages = [];

  const languages = [
    {
      value: "en",
      label: "ENG",
      src: "https://flagcdn.com/w20/gb.png",
      srcSet: "https://flagcdn.com/w20/gb.png 2x",
    },
    {
      value: "de",
      label: "GER",
      src: "https://flagcdn.com/w20/de.png",
      srcSet: "https://flagcdn.com/w20/de.png 2x",
    },
    {
      value: "sr",
      label: "SRB",
      src: "https://flagcdn.com/w20/rs.png",
      srcSet: "https://flagcdn.com/w20/rs.png 2x",
    },
    {
      value: "it",
      label: "ITA",
      src: "https://flagcdn.com/w20/it.png",
      srcSet: "https://flagcdn.com/w20/it.png 2x",
    },
    {
      value: "ru",
      label: "RUS",
      src: "https://flagcdn.com/w20/ru.png",
      srcSet: "https://flagcdn.com/w20/ru.png 2x",
    },
  ];

  const handleChangeLng = (lng) => {
    i18n.changeLanguage(lng);
    setSelectedValue(lng);
    if (isLoggedIn) {
      setUserLanguage(localStorage.getItem("jwt"), lng);
    }
  };

  const handleCookie = (cookie) => {
    localStorage.setItem("cookie", cookie);
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogOut = () => {
    handleCloseUserMenu();
    localStorage.removeItem("userName");
    dispatch(logOut());
  };

  useEffect(() => {
    setSelectedValue(i18n.language);
    console.log(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    const name = localStorage.getItem("userName");
    dispatch(setUser(name));
  }, [dispatch]);

  useEffect(() => {
    const name = localStorage.getItem("userName");
    dispatch(setUser(name));
  }, []);

  return (
    <AppBar
      sx={{
        position: "static",
        padding: "15px 0px",
        backgroundColor: theme.palette.primary.dark,
        width: "100%",
      }}
    >
      <Container maxWidth="false" onLoad={handleCookie}>
        {" "}
        <Toolbar
          disableGutters
          sx={{
            ml: {
              xs: 0,
              md: 5,
            },
          }}
        >
          <Tooltip title="Back">
            <Button
              onClick={() => {
                if (location.pathname === "/") {
                  return;
                }
                navigate(-1);
              }}
              sx={{
                color: theme.palette.primary.light,
                p: 0,
                display: { xs: "none", md: "flex" },
              }}
            >
              <ArrowBackIosIcon />
            </Button>
          </Tooltip>
          <Typography
            variant="h4"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
              alignItems: "center",
            }}
          >
            <Avatar
              alt="Termovent"
              src={proluxIcon}
              sx={{
                display: { xs: "none", md: "flex" },
                mr: 1,
                width: "60px",
                height: "60px",
              }}
            />
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              // size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  component={MuiLink}
                  href={page.href}
                  target="_blank"
                  rel="noreferrer"
                  sx={{
                    color: "inherit",
                    textDecoration: "none",
                    fontSize: 16,
                  }}
                  key={page.id}
                  onClick={handleCloseNavMenu}
                >
                  {page.name}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Typography
            variant="h5"
            noWrap
            component="a"
            href="https://termovent.com/en/"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            {/* TERMOVENT */}
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <MenuItem
                component={MuiLink}
                href={page.href}
                target="_blank"
                rel="noreferrer"
                sx={{
                  color: "inherit",
                  textDecoration: "none",
                  fontSize: 16,
                }}
                key={page.id}
                onClick={handleCloseNavMenu}
              >
                {page.name}
              </MenuItem>
            ))}
          </Box>
          <Box display="flex">
            <Box
              sx={{
                display: { xs: "none", md: "none", lg: "flex", xl: "flex" },
                justifyContent: "center",
                alignItems: "center",
                mr: 2,
              }}
            >
              {isLoggedIn && (
                <Typography sx={{ fontSize: "22px" }} variant="h6">
                  {user}
                </Typography>
              )}
            </Box>

            <Box
              sx={{
                flexGrow: 0,
                display: "flex",
                alignItems: "center",
              }}
            >
              {!isLoggedIn && (
                <Button
                  sx={{
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.primary.dark,
                    fontSize: { xs: "18px", sm: "18px" },
                    "&:hover": {
                      backgroundColor: "rgba(128,202,239, 0.8)",
                      color: theme.palette.primary.light,
                    },
                  }}
                  variant="contained"
                  onClick={() =>
                    location.pathname !== "/"
                      ? navigate("/")
                      : setModalopen(true)
                  }
                >
                  {t("navbarInternal.login")}
                </Button>
              )}
              {isLoggedIn && (
                <Tooltip title="Open settings">
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar
                      alt={user}
                      sx={{
                        background: theme.palette.primary.light,
                        color: theme.palette.primary.main,
                        width: "50px",
                        height: "50px",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              )}
              {isLoggedIn && (
                <Menu
                  disableScrollLock
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {navbarInternalLoggedIn.map((setting) => (
                    <MenuItem
                      component={Link}
                      to={setting.href}
                      key={setting.id}
                      onClick={
                        setting.name === t("navbarInternal.nameLogout")
                          ? handleLogOut
                          : handleCloseUserMenu
                      }
                    >
                      {setting.name}
                    </MenuItem>
                  ))}
                </Menu>
              )}

              <Box>
                <FormControl
                  // disableScrollLock
                  sx={{ marginLeft: "20px", width: "30", height: "20" }}
                >
                  <Select
                    onChange={handleClose}
                    // disableScrollLock

                    sx={{
                      backgroundColor: theme.palette.primary.dark,
                      color: theme.palette.secondary.main,
                      border: `1px solid ${theme.palette.secondary.main}`,
                      height: "40px",
                    }}
                    MenuProps={{
                      disableScrollLock: true,
                      PaperProps: {
                        sx: {
                          bgcolor: theme.palette.primary.dark,
                          color: theme.palette.secondary.main,
                          "& .MuiMenuItem-root": {
                            // padding: 2,
                            color: theme.palette.secondary.main,
                          },
                        },
                      },
                    }}
                    // value={20}
                    value={selectedValue}
                    renderValue={(selectedValue) => (
                      <div>
                        <img
                          src={
                            languages.find(
                              (option) => option.value === selectedValue
                            )?.src
                          }
                          alt={selectedValue}
                        />
                      </div>
                    )}
                  >
                    {languages.map((option) => (
                      <MenuItem
                        value={option.value}
                        onClick={(e) => {
                          handleChangeLng(option.value);
                        }}
                        sx={{
                          color: theme.palette.primary.dark,

                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <img
                          loading="lazy"
                          width="50px"
                          src={option.src}
                          srcSet={option.srcSet}
                          alt=""
                        ></img>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
